<template>
  <div>
    <div v-if="comment">
      <commentView
        :comment='comment'
        :isDeleteEnabled='isDeleteEnabled'>
      </commentView>
    </div>
    <div v-else>
      <commentCreate
        @commentCreateSuccess='closeCommentPopup()'
        :subsectionDataId='subsectionDataId'
        :latlng='latlng'
        :videoTime='0'
        :commentImage='commentImage'
        :commentImageURL='commentImageURL'>
      </commentCreate>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { USER_ROLES } from '@/config';
import commentView from '@/components/commentView.vue';
import commentCreate from '@/components/commentCreate.vue';


export default {
  props: ['comment', 'latlng', 'subsectionDataId', 'commentPopupHandler', 'commentImage', 'imageMarker', 'commentImageURL'],
  data() {
    return {
      isDeleteEnabled: false,
    };
  },
  mounted() {
    this.enableDeleteButton();
    // console.log(this.comment);
  },
  components: {
    commentView,
    commentCreate,
  },
  computed: {
    ...mapState([
      'auth',
    ]),
  },
  methods: {
    enableDeleteButton() {
      if (this.auth.role === USER_ROLES.ADMIN) {
        this.isDeleteEnabled = true;
      } else {
        if (this.auth.user_id === this.comment.user) {
          this.isDeleteEnabled = true;
        }
      }
    },
    closeCommentPopup() {
      this.commentPopupHandler.closePopup();
      this.$emit('IssueCreateSuccess', true);
      if(this.imageMarker!=null) {
        imageMarker.remove();
      }
    },
  },

};
</script>

<style lang="scss">
 @import '@/assets/sass/_variables.scss';

.comment-text {
  font-size: 0.8rem;
  font-weight: normal;
}

.comment-user {
  font-size: 0.8rem;
  font-weight: normal;
  padding-top: .2rem;
  text-transform: capitalize;
}

.btn {
  margin: .3rem;
}

.sd-comment-button {
  cursor: pointer;
  &:hover {
    background-color: $gray-light;
  }
}
</style>
